module.exports = __webpack_public_path__ + "static/media/66790004-VMTzwSgs.727af518.JPG";